import { createFileRoute, redirect } from "@tanstack/react-router";

// Blog settings, retired by the sidebar IA reorg (2026-08-14). It held five
// concerns with four audiences — workspace rename, blog title/description, a
// read-only domain echo, transactional template colours and the newsletter's
// sender identity — and every one of them moved to a row that names it, which
// left the page with nothing on it.
//
// Redirects to Design, where its two content fields (title, description)
// landed: the destination a bookmark holder was most likely after.
export const Route = createFileRoute("/dashboard/w/$workspaceId/settings")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/dashboard/w/$workspaceId/design",
      params: { workspaceId: params.workspaceId },
    });
  },
});
